import { fetchApi } from '@/config/axiosSetting';
import {
  GetInitialEntryTabsQueryParamsType,
  GetInitialEntryTabsQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialEntryTabs/getInitialEntryTabsQuery.type';

export const getInitialEntryTabsFunction = (
  params: GetInitialEntryTabsQueryParamsType,
): Promise<GetInitialEntryTabsQueryResponseType[]> => {
  return fetchApi.get(`initial/reports/${params?.id}/entry_tabs/`, {
    params,
  });
};
